import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader"
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme"
import AccountProfile from '../../../assets/Icons/Account_profile';
import Phone from '../../../assets/Icons/Phone';
import Email from '../../../assets/Icons/Email';
import PanCard from '../../../assets/Icons/PanCard';
import Edit from '../../../assets/Icons/Edit';
import { ActivityIndicator, Image, Platform, ScrollView } from "react-native";
import { useAppDispatch, useAppSelector } from "@app/store/hooks";
import VerificationOTP from "@app/sharedComponents/VerificationOTP/VerificationOTP";
import { endpoints } from "@app/api/apis";
import { useEffect, useState } from "react";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import axios from "axios";
import ROUTE from "@app/navigationApp/routes";
import { Clock } from "@app/sharedComponents/Icons/Icons";
import handleApiErr from "@app/helper/handleApiErr";
import { showErrorSheet } from "@app/store/slices/errorSlice";
import { LENDER_ID } from "@app/constants/platformPartners";
import BankAndMandate from "./Component/BankAndMandate";
import { updateUserProfile } from "@app/store/slices/authSlice";
import { mandateReRegistrationFlag } from "@app/utils/utils";

const AccountDetails = ({navigation,route}) => {
    const dispatch = useAppDispatch();
    const userProfile = useAppSelector(state => state.auth.userProfile);
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const pendingAccountRequest = useAppSelector((state) => state.auth.pendingAccountRequest);
    const {
        emailId = "",
        panNumber = "",
        phoneNumber = "",
        name = "",
        bankDetails = {}
    } = userProfile ?? {};
    const [isBottomSheetVisible, setIsBottomSheetVisible] = useState<boolean>(false);
    const [updateAccountAttribute, setUpdateAccountAttribute] = useState<string | null>(null);
    const lendingPartnerId = userDetails?.linkedCredits[0]?.lendingPartnerId ?? userDetails?.linkedApplications[0]?.lenderAccountId;
    const isLendinPartnerBajaj = lendingPartnerId?.toLowerCase() === LENDER_ID.BAJAJ.toLowerCase();
    const isLendinPartnerTata = lendingPartnerId?.toLowerCase() === LENDER_ID.TATA.toLowerCase();
    const [showPhoneLoader,setShowPhoneLoader] = useState<boolean>(false);
    const [showEmailLoader,setShowEmailLoader] = useState<boolean>(false);
    const {isfromTDL} = useAppSelector(state => state.platformParams);
    const firebaseParams = useAppSelector((state) => state.firebaseParams);

    const showPhoneAndEmail = firebaseParams?.show_email_and_phone_test_numbers?.includes(userDetails?.user?.phoneNumber) || firebaseParams?.show_email_and_phone === "true";
    const MANDATE_RE_REGISTER_FEATURE = mandateReRegistrationFlag(firebaseParams, userDetails?.user?.phoneNumber);

    const closeBottomSheet = () => {
        // setTimeout(()=>{setUpdateAccountAttribute(null)},1000)
        setIsBottomSheetVisible(false);
    };

    const fetchUserProfile = ()=>{
        const url = endpoints.userProfile + userDetails?.linkedApplications[0]?.accountId       
        axios.get(url).then((res)=>{
          dispatch(updateUserProfile(res?.data ?? {}))
        }).catch((err)=>{
          console.log('fetchUserProfile',err)
        })
    }

    useEffect(()=> {
        !userProfile && fetchUserProfile()
    }, []);
    
    const requestAccountVerificationOtp = (type:string) => {
        if(type === 'PHONE_NUMBER'){
            setShowPhoneLoader(true);
        }else{
            setShowEmailLoader(true);
        }
        const url = endpoints?.requestAccVerifyOtp + userDetails?.linkedApplications[0]?.accountId;
        axios.get(url)
        .then(res => {
            setIsBottomSheetVisible(true);
            setUpdateAccountAttribute(type);
        })
        .catch(err => {
            console.log('otp error',err);
            if(handleApiErr(err)){
                dispatch(showErrorSheet({
                    isErrorSheetVisible: true,
                    errorMessage: err?.data?.message,
                    closeOnBackdropPress: true,
                    errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
                    errorHeading:  err?.data?.header,
                    showErrorHeading: true,
                    btnName: 'Ok, got it!',
                }))
            }
        }).finally(()=>{
            if(type === 'PHONE_NUMBER'){
                setShowPhoneLoader(false);
            }else{
                setShowEmailLoader(false);
            }
        })
    };

    const onVerificationSuccess = (data) => {
        navigation.navigate(ROUTE.UPDATE_PHONE_EMAIL,{type:updateAccountAttribute});
    };
    
    const {requestType,updatedValue,status} = pendingAccountRequest?.[0] || {};
    const isRequestFailed = status === "FAILURE" || status === "REJECTED";
    const finalUpdateValue = requestType === "EMAIL" ? updatedValue : `+91 ${updatedValue?.slice(3)}`;
    const updateRemark = {
            title:`Request to update ${requestType === "EMAIL"? 'email Id' :'mobile number'} to ${finalUpdateValue} is in progress.`,
            subtitle:`Can't edit ${requestType === "EMAIL"? 'mobile number':'email Id'} until ongoing request is processed.`,
    }

    const showEditIcon =  !isLendinPartnerBajaj && (pendingAccountRequest?.length === 0 || isRequestFailed) ;
    const showAccountDetailUpdateRemark = pendingAccountRequest?.length > 0 && !isRequestFailed && !isLendinPartnerTata
    return(
    <>
        <PageHeaders label="Account details" pageName={route?.name} navigation={navigation}/>
        <ScrollView
            contentContainerStyle={{ padding: 16, flex: Platform.OS === 'web' ? 1 : 0, backgroundColor: themeColorSet["bg-surface-primary"], flexGrow: 1 }}
            keyboardShouldPersistTaps="handled"
            style={{
                backgroundColor: themeColorSet['white']
            }}
        >
            <ThemedView flexDirection="row">
                <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
                <AccountProfile size={24}   bgColor={themeColorSet['bg-fill-emphasis-primary-1']} color={themeColorSet['icon-action-primary']}/>
                </ThemedView>
                <ThemedView ml="md">
                    <ThemedText variant="b4r" color="text-secondary">Name</ThemedText>
                    <ThemedText variant="b3m" color="text-primary" textTransform="capitalize">{name?.toLowerCase()}</ThemedText>
                </ThemedView>
            </ThemedView>
            <ThemedView height={1} backgroundColor="border-secondary" my="lg"/>
            <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                <ThemedView flexDirection="row" flex={1}>
                    <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
                        < Phone size={24}   bgColor={themeColorSet['bg-fill-emphasis-primary-1']} color={themeColorSet['icon-action-primary']}/>
                    </ThemedView>
                    <ThemedView ml="md"  flex={1} flexWrap="wrap">
                            <ThemedText variant="b4r" color="text-secondary">Mobile number</ThemedText>
                            <ThemedText variant="b3m" color="text-primary"  numberOfLines={2} ellipsizeMode="tail">+91 {phoneNumber?.slice(3)}</ThemedText>
                            {
                                requestType === 'EMAIL' &&showAccountDetailUpdateRemark &&
                                <ThemedView flexDirection="row" alignItems="center"  mt="lg">
                                    <ThemedText variant="b4r" color="text-secondary">{updateRemark?.subtitle}</ThemedText>
                                </ThemedView>
                            }
                        </ThemedView>
                        
                </ThemedView>
                {showEditIcon && !showPhoneLoader &&
                <ThemedPressable onPress={()=>requestAccountVerificationOtp('PHONE_NUMBER')} ml="sm">
                    <Edit size={16} />
                </ThemedPressable>}
                {showPhoneLoader && <ActivityIndicator size="small" color={themeColorSet["icon-secondary"]} />}
            </ThemedView>
            {
               requestType === 'PHONE_NUMBER' && showAccountDetailUpdateRemark &&
                <ThemedView flexDirection="row" alignItems="center" p="md" backgroundColor="bg-fill-info" borderRadius="sm"  mt="lg">
                    <Clock size={20} weight="fill" color={themeColorSet["icon-secondary"]} />   
                    <ThemedText variant="b4r" color="text-secondary"  ml="md">{updateRemark?.title}</ThemedText>
                </ThemedView>
            }
            <ThemedView height={1} backgroundColor="border-secondary" my="lg"/>

            <ThemedView flexDirection="row" justifyContent="space-between" alignItems="center">
                <ThemedView flexDirection="row" flex={1}>
                    <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
                        <Email size={24}   bgColor={themeColorSet['bg-fill-emphasis-primary-1']} color={themeColorSet['icon-action-primary']}/>
                    </ThemedView>
                    <ThemedView ml="md"  flex={1} flexWrap="wrap">
                            <ThemedText variant="b4r" color="text-secondary">Email ID</ThemedText>
                            <ThemedText variant="b3m" color="text-primary" numberOfLines={2} ellipsizeMode="tail">{emailId}</ThemedText>
                            {
                         requestType === 'PHONE_NUMBER' && showAccountDetailUpdateRemark&&
                            <ThemedView flexDirection="row" alignItems="center"  mt="lg">
                                <ThemedText variant="b4r" color="text-secondary">{updateRemark?.subtitle}</ThemedText>
                            </ThemedView>
                        }
                        </ThemedView>
                        
                </ThemedView>
                {showEditIcon && !showEmailLoader &&
                <ThemedPressable onPress={()=>requestAccountVerificationOtp('EMAIL')}  ml="sm">
                    <Edit size={16} />
                </ThemedPressable>}
                {showEmailLoader && <ActivityIndicator size="small" color={themeColorSet["icon-secondary"]} />}
            </ThemedView>
            {
                requestType === 'EMAIL' && showAccountDetailUpdateRemark&&
                <ThemedView flexDirection="row" alignItems="center"  mt="lg" p="md" backgroundColor="bg-fill-info" borderRadius="sm">
                    <Clock size={20} weight="fill" color={themeColorSet["icon-secondary"]} />   
                    <ThemedText variant="b4r" color="text-secondary" ml="md">{updateRemark?.title}</ThemedText>
                </ThemedView>
            }
           
            <ThemedView height={1} backgroundColor="border-secondary" my="lg"/>
            <ThemedView flexDirection="row" mb="xl">
                <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
                 <PanCard size={24}  bgColor={themeColorSet['bg-fill-emphasis-primary-1']} color={themeColorSet['icon-action-primary']}/>
                </ThemedView>
                <ThemedView ml="md">
                    <ThemedText variant="b4r" color="text-secondary">PAN number</ThemedText>
                    <ThemedView flexDirection="row" alignItems="center">
                        <ThemedText variant={isfromTDL ? "b3b":"b3m"} color="text-primary">******</ThemedText>
                        <ThemedText variant={isfromTDL ? "b3b":"b3m"} color="text-primary">{panNumber?.slice(-4)}</ThemedText>
                    </ThemedView>
                    
                </ThemedView>
            </ThemedView>
            {
                MANDATE_RE_REGISTER_FEATURE ? 
                (
                    <ThemedView paddingBottom='3xl'>
                        <BankAndMandate navigation={navigation} route={route} isNotification={false}/>
                    </ThemedView>
                ) : (
                        <ThemedView>
                            <ThemedText variant="b4r" color="text-secondary" my="lg">Bank details</ThemedText>
                            <ThemedView>
                                <ThemedView flexDirection="row" alignItems="center">
                                    <Image source={{uri:`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${bankDetails?.bankCode}.png`}} style={{width:40,height:40}} />
                                    <ThemedText variant="b2b" color="text-primary" ml="md">{bankDetails?.bankName}</ThemedText>
                                </ThemedView>
                                <ThemedView height={1} backgroundColor="border-secondary" my="lg"/>
                                <ThemedText variant="b4r" color="text-secondary">IFSC</ThemedText>
                                <ThemedText variant="b3m" color="text-primary">{bankDetails?.ifscCode}</ThemedText>
                                <ThemedView height={1} backgroundColor="border-secondary" my="lg"/>
                                <ThemedText variant="b4r" color="text-secondary">Account number</ThemedText>
                                <ThemedText variant="b3m" color="text-primary">XXXX{bankDetails?.accountNumber?.slice(-4)}</ThemedText>
                            </ThemedView>
                        </ThemedView>
                        
                )
            }
        </ScrollView>
        <BottomSheetContainer
            isVisible={isBottomSheetVisible}
            close={closeBottomSheet}
            closeOnBackdropPress={true}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
            containsTextInput
            containerStyle={{ backgroundColor: '#fefefe' }}
        >
            <VerificationOTP 
                heading="Verify your account"
                otpType={showPhoneAndEmail ? "PHONE_AND_EMAIL" : "PHONE_NUMBER"}
                otpSentTo={phoneNumber}
                otpSentToSecondaryDetails={emailId}
                otpDigitCount={6}
                resendUrl={endpoints?.requestAccVerifyOtp + userDetails?.linkedApplications[0]?.accountId}  
                verifyUrl={endpoints?.accVerifyOtp}
                uniqueIdentifier={userDetails?.linkedCredits[0]?.creditId}
                currentStep={"ACCOUNT_DETAILS"}
    
                attributeKeyToVerify={'borrowerAccountId'}
                attributeValueToVerify={userDetails?.linkedApplications[0]?.accountId}
                onClose={closeBottomSheet}
                onVerificationSuccess={onVerificationSuccess}
                resendApiMethod={"GET"}          
                />
        </BottomSheetContainer>
    </>
    )
}
export default AccountDetails;